enum BenchmarkingPlanTypeEnum {
  HMO = "HMO",
  PPO = "PPO",
  PFFS = "PFFS",
  MSA = "MSA",
  MMP = "MMP",
  Plan1876 = "1876",
}

export { BenchmarkingPlanTypeEnum };
